import {useState} from 'react';
import AppConstants from '../../Constants/AppConstants';
import Avatar from './Avatar';
import {switchTenant} from '../../Actions/switchTenant';
import {
  clearCookies,
  encryptDataWithAES,
  saveCookies,
} from '../../HelperClasses/UserPrefrences';
import ToastPopup from '../../HelperClasses/AppLoaderClasses/ToastPopup';
import {useNavigate} from 'react-router-dom';
import {uuid} from 'uuidv4';
import {useLocale} from '../../Localization/LocaleContext';

const TenantsList = ({closeModal}) => {
  const navigate = useNavigate();
  const {translate: t} = useLocale();
  //
  const [isLoading, setIsLoading] = useState(null);

  //

  // Submit login form
  const handleSwitchTenant = async tenant => {
    let evn = 'p';
    let is_success = false;
    setIsLoading({[tenant.id]: true});
    try {
      const response = await switchTenant(tenant.id);

      if (!response?.key?.auth_key) {
        ToastPopup({
          message: response?.error || t('navigation.tenant_switch_failed', 'Tenant switch failed. Please try again.'),
          type: 'error',
        });
        return;
      }

      clearCookies(`ck_${evn}_ga`);
      clearCookies(`ck_${evn}_a`);
      clearCookies(`ck_${evn}_r`);
      clearCookies(`ck_${evn}_t`);
      clearCookies(`ck_${evn}_u`);

      if (!response.email_verified) {
        saveCookies(`ck_${evn}_ga`, encryptDataWithAES(JSON.stringify(response)));
        navigate('https://tradly.app/signin');
      } else {
        const auth_key = response.key.auth_key;
        const refresh_key = response.key.refresh_key;
        const uuid_response = encryptDataWithAES(uuid());
        const tenant_id = encryptDataWithAES(tenant.id);

        saveCookies(`ck_${evn}_a`, auth_key);
        saveCookies(`ck_${evn}_u`, uuid_response);
        saveCookies(`ck_${evn}_r`, refresh_key);
        saveCookies(`ck_${evn}_t`, tenant_id);
        saveCookies('auth_expiry_time', Date.now() + 86400);

        is_success = true;
      }
      if (is_success) {
        // Notify any embedded iframes (e.g. Intelligence / orange-ui) that the tenant changed
        document.querySelectorAll('iframe').forEach(frame => {
          try {
            frame.contentWindow?.postMessage({type: 'TRADLY_TENANT_SWITCH'}, '*');
          } catch (_) {}
        });
        closeModal();
        window.location.reload();
      }
    } catch (error) {
      ToastPopup({
        message: error?.message || t('navigation.tenant_switch_failed', 'Tenant switch failed. Please try again.'),
        type: 'error',
      });
    } finally {
      setIsLoading(null);
    }
  };

  return (
    <>
      <div className=" w-full max-h-full overflow-auto  scrollbar-none    px-12 py-6 space-y-6 pb-10">
        {/* Page header */}
        <h1 className=" text-2xl font-bold text-gray-800 text-center">
          {t('navigation.select_project', 'Select Project')}
        </h1>

        {/* Form */}
        <div className="w-full h-full flex flex-col gap-4">
          {AppConstants?.tenant_list?.map(tenant => {
            return (
              <button
                key={tenant.id}
                onClick={() => handleSwitchTenant(tenant)}
                className="w-full px-4 py-3 flex items-center justify-between text-gray-800 border border-gray-300 shadow-md">
                <div className="flex items-center gap-2 ">
                  <Avatar
                    text={tenant?.id?.slice(0, 2).toUpperCase()}
                    bg_color="#0000"
                  />
                  {tenant.id}
                </div>
                {!isLoading?.[tenant.id] ? (
                  <svg
                    fill="none"
                    className="  h-5 w-5  "
                    stroke="currentColor"
                    strokeWidth="1.5"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 4.5l7.5 7.5-7.5 7.5"></path>
                  </svg>
                ) : (
                  <svg
                    className="animate-spin   h-5 w-5  "
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24">
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default TenantsList;
